var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVentre2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 178,
    viewBox: "0 0 93 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40704 84.1738C3.40704 84.1738 0.0965175 113.774 5.06229 147.074",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.89 3.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5183 0.216064C94.1864 24.1235 93.268 41.7261 88.5229 53.5122C83.7779 65.2983 79.0763 85.7995 78.1494 97.5386C75.5208 130.293 95.7242 133.196 88.0809 177.216",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1997 0.216064C27.2644 10.5111 12.8283 28.2848 11.3699 40.0754C9.95246 51.5351 13.0803 64.4682 12.6941 70.2675C11.8679 91.2571 10.0192 109.335 12.3498 127.469C14.6804 145.603 16.8124 165.929 16.0046 177.216",
    stroke: "#909090",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVentre2);
export default __webpack_public_path__ + "static/media/M-VENTRE_2.3b0a4e147fead929dfcd7d2cef20a4a6.svg";
export { ForwardRef as ReactComponent };